import { INBOX } from '../actions/utilities';

const INITIAL_STATE = {
  getInboxChatsLoading: false,
  getInboxChatsSuccess: false,
  getInboxChatsFailure: false,
  getInboxChatsError: null,
  getInboxChats: [],

  selectedChatObj: null,
  searchValue: '',
  filterBy: 'All',
  personFilter: {
    service_provider: "no",
    customer: "no",
    booking_chat: "no",
    website_chat: "no",
  },
  filterDate: null,
};

export const InboxReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INBOX.GET_INBOX_CHATS_REQUEST:
      return {
        ...state,
        getInboxChatsLoading: true,
        getInboxChatsSuccess: false,
        getInboxChatsFailure: false,
        getInboxChatsError: null,
        // getInboxChats: [],
      };
    case INBOX.GET_INBOX_CHATS_SUCCESS:
      return {
        ...state,
        getInboxChatsLoading: false,
        getInboxChatsSuccess: true,
        getInboxChatsFailure: false,
        getInboxChatsError: null,
        getInboxChats: action.payload,
      };
    case INBOX.GET_INBOX_CHATS_FAILURE:
      return {
        ...state,
        getInboxChatsLoading: false,
        getInboxChatsSuccess: false,
        getInboxChatsFailure: true,
        getInboxChatsError: action.payload,
      };
    case INBOX.SET_SELECTED_CHAT_OBJECT:
      return {
        ...state,
        selectedChatObj: action.payload,
      };
    case INBOX.SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
      };
    case INBOX.SET_FILTER_BY:
      return {
        ...state,
        filterBy: action.payload,
      };
    case INBOX.SET_PERSON_FILTER:
      return {
        ...state,
        personFilter: action.payload,
      };
    case INBOX.SET_FILTER_DATE:
      return {
        ...state,
        filterDate: action.payload,
      };
    default:
      return state;
  }
};
